export default __webpack_public_path__ + "static/media/miles-lettinga.92889bdc.jpg";